import React, { useState } from "react";
import dayjs from "dayjs";
import {
    Card,
    CardTitle,
    CardContent,
    CardLoadMore,
    DataTable,
    Badge,
    Column,
    Cell,
    Text
} from "@tv2no/ui-react";
import { ImportEntry } from "./ImportEntry";

export const ImportHistory = ({ taxYear, historyList, busyLoading, pageNumber, setPageNumber }) => {
    const [selectedImport, setSelectedImport] = useState(null);

    return (
        <React.Fragment>
            <Card>
                <CardTitle title="Importhistorikk">
                    <Badge fill number>
                        {historyList?.totalElements}
                    </Badge>
                </CardTitle>
                <CardContent borderBottom={historyList && !historyList.last}>
                    {!busyLoading && !historyList?.content?.length ? (
                        <Text opacity={50}>Ingen importer er utført.</Text>
                    ) : (
                        <DataTable
                            rows={historyList?.content}
                            busy={busyLoading}
                            onRowClick={setSelectedImport}
                        >
                            <Column
                                label="Startet"
                                cell={({ row }) => <Cell>{dayjs(row.started).format("LLL")}</Cell>}
                            />
                            <Column
                                label="Datagrunnlag"
                                cell={({ row }) => <Cell>{row.fileData.name}</Cell>}
                            />
                            <Column
                                label="Varighet"
                                cell={({ row }) => (
                                    <Cell>{Math.round(row.duration / 1000)} sek</Cell>
                                )}
                            />
                            <Column
                                label="Testkjøring"
                                cell={({ row }) => (
                                    <Cell>
                                        {row.dryRun ? (
                                            <Text color="info">Ja</Text>
                                        ) : (
                                            <Text>Nei</Text>
                                        )}
                                    </Cell>
                                )}
                            />
                            <Column
                                label="Resultat"
                                cell={({ row }) => (
                                    <Cell>
                                        {row.failed ? (
                                            <Badge color="error">Feilet</Badge>
                                        ) : row.finished ? (
                                            <Badge color="success">Fullført</Badge>
                                        ) : null}
                                    </Cell>
                                )}
                            />
                        </DataTable>
                    )}
                </CardContent>

                {historyList && !historyList.last ? (
                    <CardLoadMore
                        busy={busyLoading}
                        onClick={() => setPageNumber(pageNumber + 1)}
                        progress={
                            ((historyList.number * historyList.size +
                                historyList.numberOfElements) /
                                historyList.totalElements) *
                            100
                        }
                    />
                ) : null}
            </Card>

            {selectedImport ? (
                <ImportEntry entry={selectedImport} onClose={() => setSelectedImport(null)} />
            ) : null}
        </React.Fragment>
    );
};
